import { comics, editorPicks, hotComicIds, newComicIds } from '@/mocks/comics';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import ComicSection from './components/ComicSection';
import RankingPanel from './components/RankingPanel';

const byIds = (ids: string[]) =>
  ids.map((id) => comics.find((comic) => comic.id === id)).filter(Boolean);

export default function Home() {
  return (
    <>
      <HeroBanner />
      <CategoryGrid />
      <ComicSection
        title="热门推荐"
        subtitle="大家都在追的高人气作品"
        moreLink="/list?sort=hot"
        comics={byIds(hotComicIds) as typeof comics}
        tone="primary"
      />
      <div className="w-full bg-background-100">
        <ComicSection
          title="新作上线"
          subtitle="最新连载，抢先追更不错过"
          moreLink="/list?sort=new"
          comics={byIds(newComicIds) as typeof comics}
          tone="secondary"
        />
      </div>
      <ComicSection
        title="编辑精选"
        subtitle="编辑部人手一份的私藏好漫"
        moreLink="/list?sort=rank"
        comics={byIds(editorPicks) as typeof comics}
        tone="accent"
      />
      <RankingPanel />
    </>
  );
}